import React from "react";

export default function SummarySkeleton() {
  return (
    <div className="p-6 space-y-8 animate-pulse">
      {/* Header and Filters */}
      <div className="flex items-start justify-between mb-2">
        <div>
          <div className="h-10 w-96 bg-gray-200 rounded mb-2" /> {/* Title */}
          <div className="h-5 w-80 bg-gray-100 rounded" /> {/* Subtext */}
        </div>
        <div className="h-8 w-24 bg-gray-200 rounded" /> {/* Filters button */}
      </div>

      {/* Metric Cards */}
      <div className="flex gap-6 mb-2">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="bg-gray-100 rounded-lg h-24 w-56" />
        ))}
      </div>

      {/* Chart Controls */}
      <div className="flex gap-8 items-center mb-2">
        <div className="h-8 w-40 bg-gray-100 rounded" />
        <div className="h-8 w-40 bg-gray-100 rounded" />
      </div>

      {/* Chart and Budget Metrics */}
      <div className="flex gap-6 mb-6">
        <div className="flex-1 flex flex-col items-center">
          <div className="bg-gray-200 rounded-xl h-[400px] w-full max-w-4xl" />
        </div>
        <div className="w-[260px] space-y-4 pt-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="bg-gray-100 rounded-lg h-20 w-full" />
          ))}
        </div>
      </div>

      {/* Table Heading */}
      <div className="bg-white rounded-lg shadow p-4 mb-2">
        <div className="h-8 bg-gray-200 rounded w-40 mb-4" /> {/* Table title */}
        {/* Table header row */}
        <div className="flex gap-4 mb-2">
          {[...Array(11)].map((_, i) => (
            <div key={i} className="h-6 w-24 bg-gray-100 rounded" />
          ))}
        </div>
        {/* Table rows */}
        <div className="space-y-2">
          {[...Array(6)].map((_, rowIdx) => (
            <div key={rowIdx} className="flex gap-4">
              {[...Array(11)].map((_, colIdx) => (
                <div key={colIdx} className="h-6 w-24 bg-gray-200 rounded" />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 